import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Browse from "@/pages/Browse";
import PropertyDetail from "@/pages/PropertyDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import LandlordDashboard from "@/pages/LandlordDashboard";
import RenterDashboard from "@/pages/RenterDashboard";
import PaymentReturn from "@/pages/PaymentReturn";
import Admin from "@/pages/Admin";
import ResetPassword from "@/pages/ResetPassword";
import Onboard from "@/pages/Onboard";
import DispatchResponse from "@/pages/DispatchResponse";

function Dashboard() {
  const { user } = useAuth();
  if (user?.role === "admin") return <Navigate to="/admin" replace />;
  return user?.role === "landlord" ? <LandlordDashboard /> : <RenterDashboard />;
}

function AdminRoute() {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <Admin />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/browse" element={<Browse />} />
              <Route path="/property/:id" element={<PropertyDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/onboard" element={<Onboard />} />
              <Route path="/dispatch" element={<DispatchResponse />} />
              <Route path="/payment-return" element={<PaymentReturn />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><AdminRoute /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
